import {createSvgIcon} from "@buildwitt/shapeshift-common/v1/icon";

export const IconUpArrow = createSvgIcon(
	<path d="M17 8L9.37689 1.14063C9.32742 1.09605 9.26867 1.06068 9.204 1.03655C9.13933 1.01242 9.07001 1 9 1C8.92999 1 8.86067 1.01242 8.796 1.03655C8.73133 1.06068 8.67258 1.09605 8.62311 1.14063L1 8" stroke="#FF9E00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>,
	"UpArrow",
	"0 0 20 20"
);